import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useRestrictedActionShowState() {
  return useAppState();
}

export function useRestrictedActionShowActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      restrictedAction: null,
      restrictedActionEditModalIsOpen: false,
      deleteRestrictedActionModalIsOpen: false,
      addRoleModalIsOpen: false,
      addUserModalIsOpen: false,
      newRole: {
        id: '',
      },
      newUser: {
        id: '',
      },
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function openRestrictedActionEditModal() {
    dispatch((appState) => ({
      ...appState,
      restrictedActionEditModalIsOpen: true,
    }));
  }

  function closeRestrictedActionEditModal() {
    dispatch((appState) => ({
      ...appState,
      restrictedActionEditModalIsOpen: false,
    }));
  }

  function openDeleteRestrictedActionModal() {
    dispatch((appState) => ({
      ...appState,
      deleteRestrictedActionModalIsOpen: true,
    }));
  }

  function closeDeleteRestrictedActionModal() {
    dispatch((appState) => ({
      ...appState,
      deleteRestrictedActionModalIsOpen: false,
      deleteConfirmationPhrase: '',
    }));
  }

  function updateDeleteConfirmationPhrase(phrase) {
    dispatch((appState) => ({
      ...appState,
      deleteConfirmationPhrase: phrase,
    }));
  }

  function openAddRoleModal() {
    dispatch((appState) => ({
      ...appState,
      addRoleModalIsOpen: true,
    }));
  }

  function closeAddRoleModal() {
    dispatch((appState) => ({
      ...appState,
      addRoleModalIsOpen: false,
      newRole: { id: '' },
    }));
  }

  function openAddUserModal() {
    dispatch((appState) => ({
      ...appState,
      addUserModalIsOpen: true,
    }));
  }

  function closeAddUserModal() {
    dispatch((appState) => ({
      ...appState,
      addUserModalIsOpen: false,
      newUser: { id: '' },
    }));
  }

  function updateNewRoleId(roleId) {
    dispatch((appState) => ({
      ...appState,
      newRole: {
        id: roleId,
      },
    }));
  }

  function updateNewUserId(userId) {
    dispatch((appState) => ({
      ...appState,
      newUser: {
        id: userId,
      },
    }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    openRestrictedActionEditModal,
    closeRestrictedActionEditModal,
    openDeleteRestrictedActionModal,
    closeDeleteRestrictedActionModal,
    updateDeleteConfirmationPhrase,
    openAddRoleModal,
    closeAddRoleModal,
    openAddUserModal,
    closeAddUserModal,
    updateNewRoleId,
    updateNewUserId,
    getFeedbackFromLocalStorage,
    clearFeedback,
  };
}
